<a href="javascript:void(0)" (click)="openModal()">
    @if (configuration.labelIcon) {
    <fa-icon [icon]="configuration.labelIcon"></fa-icon>
    }
    {{ configuration.label }}
</a>
